import * as LINKS from "./links";
import * as ENDPOINTS from "./endpoints";

export { default as envs } from "./envs";
export { default as redirects } from "./redirects";
export { default as menuProdutos } from "./produtos";
export { default as requestAxios } from "./request";
export * from "./produtos";
export * from "./chat";

export const links = LINKS;
export const endpoints = ENDPOINTS;
